require("-!style-loader!css-loader!less-loader!/home/jenkins/work/workspace/Lumo_deploy_feature-test-3/node_modules/font-awesome-webpack/font-awesome-styles.loader.js!/home/jenkins/work/workspace/Lumo_deploy_feature-test-3/src/webComponents/font-awesome.config.js");


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome-webpack/index.loader.js!./src/webComponents/font-awesome.config.js
// module id = 223
// module chunks = 2